/**
 * Auth Controller login endpoints (relative paths).
 *
 * These are same-origin relative URLs because the deconsolidated login page
 * is served from the Auth Controller's CloudFront distribution.
 * Using relative paths ensures the login flow stays on whichever domain
 * the user arrived on (new domain or legacy), preserving the X-ATOZ-SOURCE
 * header for correct domain-aware URL resolution in the Auth Controller.
 */
const AuthEndpoints = {
    AA: '/login?loginType=AA',
    DA: '/login?loginType=DA',
    DSP: '/login?loginType=DSP',
    DSPA: '/login?loginType=DSPA',
    PB: '/login?loginType=PB',
    SRU: '/login?loginType=SRU',
    JOBSEEKER: '/login?loginType=JOBSEEKER',
    CSGO_NA: '/login?loginType=CSGO&region_hint=NA',
    CSGO_EU: '/login?loginType=CSGO&region_hint=EU',
    CSGO_FE: '/login?loginType=CSGO&region_hint=FE',
    // Consolidated login entry point, which detects the user type itself
    // rather than taking an explicit loginType.
    CONSOLIDATED_LOGIN: '/authenticate',
} as const;

/**
 * Login target for the jobseeker entry points. The consolidated login page is
 * now launched in all stages, so jobseeker entry points always route to the
 * consolidated `/authenticate` experience.
 */
export const jobseekerLoginEndpoint = (): string => AuthEndpoints.CONSOLIDATED_LOGIN;

export default AuthEndpoints;
